export const authenticationConstant = {
    LOGIN_FAIL: 'LOGIN_FAIL', 
    LOGIN_SUCCESS: 'LOGIN_SUCCESS', 
    LOGIN_REQUEST: 'LOGIN_REQUEST', 
    LOG_OUT: 'LOG_OUT', 
};

export default authenticationConstant;